<template>
  <div
    class="bbp-accordion-content"
    :class="{'bbp-accordion-content_open': !isHidden}"
    :style="{height: !isHidden ? heightContent : 0}"
  >
    <transition name="bbp-slide-select">
      <div
        v-if="display"
        ref="bbpDescriptionText"
        :class="[
          'bbp-accordion-content__wrap',
          isHidden && 'bbp-accordion-content__wrap_hide'
        ]"
      >
        <div class="bbp-accordion-content-item">
          <div class="bbp-accordion-content-item-time">
            <div>Tracked time</div>
            <div>
              <i class="bbp-icon-clock"/>
              {{ totalTime }}
            </div>
          </div>
        </div>
        <div class="bbp-accordion-content-item">
          <BBPAccordionContentCellAdd
            v-if="!isNoClick"
            :heightContent.sync="heightContent"
            :offsetHeight.sync="offsetHeight"
            :row="row"
            :isItemsLength="isItemsLength"
            :items="items"
          />
        </div>
        <div
          v-for="item in comments"
          :key="item._id"
          class="bbp-accordion-content-item"
        >
          <div>
            <div class="bbp-accordion-content-item__container">
              <div class="bbp-accordion-content-item__wrap">
                <span class="bbp-accordion-content-item__name">{{name(item)}}</span>
                <span> commented</span>
                <BBPAccordionContentCellTotalTime
                  v-if="item.totalTime"
                  :item="item"
                  :isEdit="!!isEdit"
                />
                <BBPTimerModalManualCounter
                  v-if="item.totalTime && isEdit === item._id"
                  :manualTimer="totalTimeComment(item)"
                  @update="updateTotalTimer"
                />
                <span
                  v-if="!isNoClick && !isEdit"
                  v-html="editIcon()"
                  class="bbp-accordion-content-item__icon"
                  @click="onEditComment(item)"
                />
              </div>
              <BBPAccordionContentCellButtons
                v-if="isEdit === item._id"
                :item="item"
                @onSave="onSave"
                @onClose="onClose"
              />
            </div>
            <BBPAccordionContentCellAdd
              v-if="isEdit === item._id"
              :heightContent.sync="heightContent"
              :offsetHeight="offsetHeight"
              :currentItem="item"
              :row="row"
              :isEditMode="true"
              :isEdit.sync="isEdit"
              :isCancel="isCancel"
              :isSave="isSave"
              :isItemsLength="isItemsLength"
              :items="items"
              :currentTime.sync="currentTime"
            />
            <div
              :class="[
                'bbp-accordion-content-item__comment',
                isEdit === item._id && 'bbp-accordion-content-item__comment_hide'
              ]"
              :id="`bbp-accordion-content-item__comment_${item._id}`"
            >{{item.comment}}</div>
          </div>
          <div class="bbp-accordion-content-item__date">
            {{item.dateAll}}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {get} from 'lodash'
import moment from 'moment'
import convertSecondsToTime from '@/mixin/convertSecondsToTime'
import totalSeconds from '@/mixin/createMilliseconds'
import sortByDate from '@/mixin/sortByDate'
import BBPAccordionContentCellAdd from '@/components/Main/BBPTable/BBPAccordionCell/BBPAccordionContentCellAdd'
import { EDIT_ICON } from '@/constants/icons'
import BBPAccordionContentCellButtons from '@/components/Main/BBPTable/BBPAccordionCell/BBPAccordionContentCellButtons'
import BBPAccordionContentCellTotalTime
  from '@/components/Main/BBPTable/BBPAccordionCell/BBPAccordionContentCellTotalTime'
import BBPTimerModalManualCounter
  from '@/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalManual/BBPTimerModalManualCounter'

export default {
  name: 'BBPAccordionContentCell',
  props: ['row', 'column'],
  components: {
    BBPAccordionContentCellButtons,
    BBPAccordionContentCellAdd,
    BBPTimerModalManualCounter,
    BBPAccordionContentCellTotalTime
  },
  mixins: [convertSecondsToTime, sortByDate, totalSeconds],
  data () {
    return {
      heightContent: 'auto',
      offsetHeight: 0,
      isHidden: true,
      editIcon: EDIT_ICON,
      isEdit: '',
      isCancel: false,
      isSave: false,
      isItemsLength: false,
      comments: [],
      currentTime: 0
    }
  },
  computed: {
    isNoClick () {
      const { isNoClick = false } = this.column
      return isNoClick
    },
    display () {
      return get(this.row, '$accordionContent', false)
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    items () {
      return get(this.row, this.column.prop, '')
    },
    totalTime () {
      const { totalTime = 0 } = this.row
      const sec = Math.floor(totalTime / 1000)
      if (!sec) return '00:00:00'
      return this.convertSecondsToTime(sec, true)
    }
  },
  methods: {
    updateTotalTimer (data) {
      this.currentTime = this.totalSeconds(data)
    },
    onSave () {
      this.isSave = !this.isSave
    },
    onClose () {
      this.isCancel = !this.isCancel
    },
    onEditComment (item) {
      this.isEdit = item._id
    },
    setOpen () {
      this.isHidden = !this.display
    },
    calcHeight () {
      const node = this.$refs.bbpDescriptionText
      this.heightContent = node ? node.offsetHeight + 'px' : 'auto'
      this.offsetHeight = node ? node.offsetHeight : 0
      this.setOpen()
    },
    date (item) {
      const { date, startDate, createdAt } = item
      const newDate = moment(date || startDate).format('DD-MMM-YY')
      const time = moment(createdAt).format('h:mm a')
      return `${newDate} at ${time}`
    },
    dateBySort (item) {
      const { date, startDate, createdAt } = item
      const newTime = moment(new Date(createdAt)).format('HH:mm:ss')
      const d = moment(new Date(date || startDate)).format('YYYY-MM-DD')
      const fullDate = `${d}T${newTime}`
      return fullDate
    },
    name ({user = []}) {
      const userId = get(this.userInfo, 'id', '5f8097e4e06d0800124c7a5d')
      const [item] = user
      const { username, _id } = item || {}
      return userId === _id ? 'You' : username
    },
    updateComments () {
      const items = this.items.map((el) => {
        return {
          ...el,
          dateAll: this.date(el),
          dateBySort: this.dateBySort(el)
        }
      })
      this.comments = this.sortByDate(items, 'dateBySort', -1, 1)
    },
    totalTimeComment ({totalTime = 0}) {
      const sec = Math.floor(totalTime / 1000)
      if (!sec) return '00:00:00'
      return this.convertSecondsToTime(sec, true)
    }
  },
  watch: {
    display (newVal) {
      if (newVal) {
        this.$nextTick(this.calcHeight)
      } else {
        this.isHidden = true
      }
    },
    items () {
      this.isItemsLength = !this.isItemsLength
      this.updateComments()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-accordion-content {
    @include global-font;
    transition: 0.25s ease-out;
    font-size: 12px;
    line-height: 16px;
    color: $color-gray;

    &__wrap {
      padding: 16px;
      border-radius: 4px;
      background-color: $color-wild-sand;
      transition: 0.3s;

      &_hide {
        opacity: 0;
        z-index: -1;
        pointer-events: none;
      }
    }
  }

  .bbp-accordion-content-item {
    display: grid;
    grid-template-columns: 1fr 250px;

    &__container {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__wrap {
      display: flex;
      align-items: center;
      grid-gap: 0 4px;
      position: relative;
    }

    &__icon {
      display: flex;
      margin: 0 0 0 -4px;
      cursor: pointer;
      transition: 0.15s;

      &:hover {
        opacity: 0.9;
      }
    }

    &__name {
      text-transform: capitalize;
      color: $color-denim;
    }

    &__comment {
      color: $color-black;
      white-space: pre-wrap;

      &_hide {
        visibility: hidden;
        z-index: -1;
        position: absolute;
      }
    }

    &__date {
      text-align: end;
    }
  }

  .bbp-accordion-content-item-time {
    display: grid;
    grid-template-columns: max-content max-content;
    grid-gap: 0 8px;
    align-items: center;

    &__icon {
      color: $color-denim;
    }

    i {
      font-size: 14px;
      line-height: 1;
      color: $color-denim;
    }

    &:first-child {
      margin-bottom: 16px;
    }
  }
</style>

<style lang="scss">
@import "../../../../sass/variables";

  .bbp-accordion-content-item__icon svg {
    width: 25px;
    height: 25px;

    path {
      fill: $color-silver;
    }
  }

  .bbp-accordion-content-item__container {
    .BBP-timer-modal-manual-counter .time-picker input {
      height: 26px !important;
      padding: 6px 8px 6px 8px !important;
      width: 80px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPAccordionCell/BBPAccordionContentCell.vue